export enum ExperienceFeatures {
  GlobalChat = 'GLOBAL_CHAT',
  PrivateChat = 'PRIVATE_CHAT',
  Broadcast = 'BROADCAST',
  Hoverboard = 'HOVERBOARD',
  Camera = 'CAMERA',
  Mic = 'MIC',
  Participants = 'PARTICIPANTS',
  OnlineUsers = 'ONLINE_USERS',
  Teleport = 'TELEPORT',
  TeleportUEWindow = 'TELEPORT_UE_WINDOW',
  LaserPointer = 'LASER_POINTER',
  Magnifier = 'MAGNIFIER',
  Emojis = 'EMOJIS',
  Reactions = 'REACTIONS',
  Map = 'MAP',
  AnalyticsPerformance = 'ANALYTICS_PERFORMANCE',
  ToggleView = 'TOGGLE_VIEW',
  FollowMe = 'FOLLOW_ME',
  GuidedTutorialsWeb = 'GUIDED_TUTORIALS_WEB',
  GuidedTutorialsUe = 'GUIDED_TUTORIALS_UE',
  RaiseHand = 'RAISE_HAND',
  AiAssistant = 'AI_ASSISTANT',
  AskMeAnything = 'ASK_ME_ANYTHING',
}

export interface IBaseFeatureConfig {
  enabled: boolean;
  config?: string;
}

export interface IExperienceFeatureSettings {
  GLOBAL_CHAT?: IBaseFeatureConfig;
  PRIVATE_CHAT?: IBaseFeatureConfig;
  BROADCAST?: IBaseFeatureConfig;
  HOVERBOARD?: IBaseFeatureConfig;
  CAMERA?: IBaseFeatureConfig;
  MIC?: IBaseFeatureConfig;
  PARTICIPANTS?: IBaseFeatureConfig;
  ONLINE_USERS?: IBaseFeatureConfig;
  TELEPORT?: IBaseFeatureConfig;
  TELEPORT_UE_WINDOW?: IBaseFeatureConfig;
  LASER_POINTER?: IBaseFeatureConfig;
  MAGNIFIER?: IBaseFeatureConfig;
  EMOJIS?: IBaseFeatureConfig;
  REACTIONS?: IBaseFeatureConfig;
  MAP?: IBaseFeatureConfig;
  ANALYTICS_PERFORMANCE?: IBaseFeatureConfig;
  TOGGLE_VIEW?: IBaseFeatureConfig;
  FOLLOW_ME?: IBaseFeatureConfig;
  GUIDED_TUTORIALS_WEB?: IBaseFeatureConfig;
  GUIDED_TUTORIALS_UE?: IBaseFeatureConfig;
  RAISE_HAND?: IBaseFeatureConfig;
  AI_ASSISTANT?: IBaseFeatureConfig;
  ASK_ME_ANYTHING?: IBaseFeatureConfig;
}
